import { getLayoutContextValue } from '@ott/layout-context';

export const getDeviceType = () => {
  return getLayoutContextValue().isMobile ? 'mobile' : 'desktop';
};
